export default __webpack_public_path__ + "static/home-page-career-science-60bbc9ac933f33ee981a97e80504fe7f.png";